<script setup lang="ts">
defineProps<{ value?: boolean; disabled?: boolean }>()
defineEmits<{ (e: 'update:modelValue', value: boolean): void }>()
</script>

<template>
  <div
    class="student-night-switch"
    :class="{ 'student-night-switch_disabled': disabled }"
    role="switch"
    :aria-checked="value"
    @click="() => $emit('update:modelValue', !value)"
  >
    <div class="student-night-switch__switch" :class="{ 'student-night-switch__switch_on': value }">
      <v-icon>student-v2/moon</v-icon>
      <div class="student-night-switch__handle" />
      <v-icon>student-v2/moon</v-icon>
    </div>
  </div>
</template>

<style lang="scss">
.student-night-switch {
  display: inline-block;
  width: 76px;
  height: 40px;
  background: #ccc;
  border-radius: 999px;
  position: relative;
  cursor: pointer;
  outline: none;

  &_disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__switch {
    width: 100%;
    height: 100%;
    border-radius: 999px;

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      background: linear-gradient(108.3deg, #2d2c72 23.49%, #231442 76.7%);
      border-radius: 999px;
      position: absolute;

      transition: opacity 0.3s ease;
      opacity: 0;
      z-index: 0;
    }

    &_on::after {
      opacity: 1;
    }

    & > * {
      z-index: 1;
    }
  }

  &__switch_on > &__handle {
    transform: translateX(36px);
  }

  &__handle {
    width: 34px;
    height: 34px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: transform 0.3s ease;
  }

  .v-icon {
    position: absolute;
    top: 8px;

    &:first-child {
      left: 8px;
    }
    &:last-child {
      right: 8px;
    }
  }
}
</style>
